import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';

import { ajax, parseDate } from 'svs-utils/web';
import { createAlert, Table2 } from 'svs-utils/react';

import { UploadFileDialog } from './dialogs/dialogs.js';

import './flightLogs.scss';

var flightLogsTableHeaderGroups = [
    // { name: 'Num', headers: ['id'] },
    { name: 'Launch', headers: ['id', 'date', 'season', 'timeOfDay', 'location'] },
    { name: 'Equipment', headers: ['wing', 'paramotor', 'engine', 'odometer', 'fuelUsed'] },
    { name: 'Flight', headers: ['duration', 'flightNotes'] },
    { name: 'Weather', headers: ['temperature', 'wind', 'gusts', 'windDirection', 'weatherSummary', 'weatherNotes'] },
];
var flightLogsTableHeaders = [
    { key: 'id', label: 'Flight', dataType: 'number', className: 'centered', width: 50 },
    { key: 'date', label: 'Date', dataType: 'date', width: 180, dateFormat: 'ddd mmm d, yyyy h:MM tt' },
    { key: 'season', label: 'Season', dataType: 'string', width: 70 },
    { key: 'timeOfDay', label: 'Time of Day', dataType: 'string', width: 100 },
    { key: 'location', label: 'Location', dataType: 'string', width: 200 },
    { key: 'wing', label: 'Wing', dataType: 'string', width: 150 },
    { key: 'paramotor', label: 'Paramotor', dataType: 'string', width: 150 },
    { key: 'engine', label: 'Engine', dataType: 'string', width: 150 },
    { key: 'odometer', label: 'Odometer', dataType: 'number', width: 80 },
    { key: 'fuelUsed', label: 'Fuel Used', dataType: 'number', width: 80 },
    { key: 'duration', label: 'Duration', dataType: 'string', width: 80 },
    { key: 'flightNotes', label: 'Flight Notes', dataType: 'string', width: 150 },
    { key: 'temperature', label: 'Temperature', dataType: 'number', width: 100 },
    { key: 'wind', label: 'Wind Speed', dataType: 'number', width: 100 },
    { key: 'gusts', label: 'Gusts Speed', dataType: 'number', width: 100 },
    { key: 'windDirection', label: 'Wind Direction', dataType: 'string', width: 110 },
    { key: 'weatherSummary', label: 'Weather Summary', dataType: 'string', width: 150 },
    { key: 'weatherNotes', label: 'Weather Notes', dataType: 'string', width: 150 },
];

function FlightLogs(props) {
    var [errorMessage, setErrorMessage] = useState('');
    var [flightLogs, setFlightLogs] = useState([]);
    var [lastUpdated, setLastUpdated] = useState(null);
    var [uploadFileDialog, setUploadFileDialog] = useState(null);

    useEffect(() => {
        getFlightLogs();
    }, []);

    var getFlightLogs = async () => {
        var results = await ajax({ endPoint: '/getFlightLogs' });
        if (results.result) {
            var newFlightLogs = results.flightLogs.map((flightLog) => ({
                ...flightLog,
                date: parseDate(flightLog.date),
            }))
            setFlightLogs(newFlightLogs);
            setLastUpdated(new Date());
        } else {
            setErrorMessage(results.desc);
        }
    };

    var handleUpload = async (files) => {
        var filesData = new FormData();

        for (var file of files) {
            filesData.append('flightFiles', file, file.name);
        }

        var results = await ajax({ endPoint: '/uploadFiles', data: { flightId: uploadFileDialog.id }, filesData });
        if (results.result) {
            var flightLog = flightLogs.find((log) => log.id === uploadFileDialog.id);
            if (flightLog) {
                flightLog.otherInfo = { ...flightLog.otherInfo, ...results.otherInfo };
            }

            setFlightLogs([...flightLogs]);
            setUploadFileDialog(null);
        } else {
            createAlert(results.desc);
        }
    };

    var flightLogsClickGroups = [
        [
            { name: 'Edit', onClick: (flightLog) => {} },
            {
                name: 'Upload Files',
                onClick: (flightLog) => setUploadFileDialog({ ...flightLog }),
                shouldShow: (flightLog) => !(flightLog.otherInfo.igcFile && flightLog.otherInfo.kmlFile),
            },
        ],
    ];

    var flightLogsTableRows = flightLogs.map((flightLog) => ({
        ...flightLog,
        rowId: flightLog.id,
        noContextObject: flightLog,
    }));

    return (
        <React.Fragment>
            {uploadFileDialog && (
                <UploadFileDialog
                    params={uploadFileDialog}
                    close={() => setUploadFileDialog(null)}
                    submit={handleUpload}
                />
            )}
            <div className='bots'>
                <div className='botsHeader'>
                    <div className='contentHeader'>Flight Logs</div>
                    <div className='lastUpdatedContainer'>{lastUpdated && `Last Updated: ${dateFormat(lastUpdated, 'mmm dS, yyyy "at" hh:MM:ss tt')}`}</div>
                </div>
                {errorMessage || (
                    <React.Fragment>
                        <div className='botsSectionHeader'>Logs</div>
                        <div className='botsChartContainer homeBoxShadow'>
                            {!!flightLogsTableRows.length && (
                                <Table2
                                    headerGroups={flightLogsTableHeaderGroups}
                                    headers={flightLogsTableHeaders}
                                    rows={flightLogsTableRows}
                                    clickGroups={flightLogsClickGroups}
                                    alternateColors={true}
                                    maxHeight={500}
                                />
                            )}
                        </div>
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    );
}

export default FlightLogs;
